<template>
  <div v-if="isVisible" class="modal-backdrop fade show"></div>
  <div
    class="modal fade show"
    :class="{ 'd-block': isVisible }"
    tabindex="-1"
    role="dialog"
    aria-labelledby="alertDialogLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="alertDialogLabel">알림</h5>
          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            @click="handleClose"
          ></button>
        </div>
        <div class="modal-body">{{ message }}</div>
        <div class="modal-footer">
          <template v-if="type === 'confirm'">
            <button
              type="button"
            class="btn btn-secondary btn-sm"
            @click="handleCancel"
          >
            아니오
          </button>
          <button type="button" class="btn btn-primary btn-sm" @click="handleConfirm">
            맞아요
          </button>
          </template>
          <template v-else>
            <button type="button" class="btn btn-primary btn-sm" @click="handleConfirm">
              확인
            </button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true
    },
    isVisible: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      default: 'alert',
      validator: (value) => ['alert', 'confirm'].includes(value)
    }
  },
  methods: {
    handleClose() {
      this.$emit('cancel')
    },
    handleCancel() {
      this.$emit('cancel')
    },
    handleConfirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped>
.modal-backdrop.show {
  opacity: 0.5; /* Bootstrap default */
}
.modal.fade.show {
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
}
</style>
